import React, { Component } from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { renderInput, renderSelectField } from 'src/components/misc/redux-form-helpers';
import TextDatePicker from 'src/components/misc/TextDatePicker';
import { isNonNegativeIntegerPercent } from 'src/common/index';
import { MenuItem } from 'material-ui';
import _ from 'lodash';
import { connect } from 'react-redux';
import SchoolEditForm from 'src/components/admin/schools/school-edit-form';
import CustomTooltip from 'src/components/misc/CustomTooltip';

class CustomerGroupDiscountEditForm extends Component {
    render() {
        const { customerGroups, handleSubmit, t } = this.props;
        console.log(this.props.effectiveFrom, 'myProps');
        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="customerGroup"
                            label={`${t('customer_group.group')} *`}
                            component={renderSelectField}>
                            {this.getCustomerGroupMenuItems()}
                        </Field>
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="discount"
                            label={t('customer_group.discount_percent')}
                            hintText={t('customer_group.discount_percent')}
                            component={renderInput}
                            type="number"
                            unit="%"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Field
                            name="effectiveFrom"
                            label={t('customer_group.effectiveFrom')}
                            component={TextDatePicker}
                            maxDate={this.props.effectiveUntil ? this.props.effectiveUntil : undefined}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="effectiveUntil"
                            label={t('customer_group.effectiveUntil')}
                            component={TextDatePicker}
                            minDate={this.props.effectiveFrom ? this.props.effectiveFrom : undefined}
                        />
                    </div>
                </div>
                <div className="row" style={{ overflow: 'unset !important' }}>
                    <div className="col-md-6">
                        <Field
                            name="effectiveFromTrip"
                            label={t('customer_group.effectiveFromTrip')}
                            component={TextDatePicker}
                            maxDate={this.props.effectiveUntilTrip ? this.props.effectiveUntilTrip : undefined}
                        />
                        <CustomTooltip
                            id="effectiveFromTrip"
                            text={t('customer_group.conjunction_effective')}
                            place="top"
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="effectiveUntilTrip"
                            label={t('customer_group.effectiveUntilTrip')}
                            component={TextDatePicker}
                            minDate={this.props.effectiveFromTrip ? this.props.effectiveFrom : undefined}
                        />
                    </div>
                </div>
            </form>
        );
    }

    getCustomerGroupMenuItems() {
        const { t, customerGroups } = this.props;

        return _.map(customerGroups.items, customerGroup => (
            <MenuItem
                key={customerGroup.id}
                value={customerGroup['_links']['self']['href']}
                primaryText={t(`customer_groups.id.${customerGroup.id}`)}
            />
        ));
    }
}
const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    if (!values.customerGroup) errors.customerGroup = t('customer_group.error_group');

    if (!isNonNegativeIntegerPercent(values.discount) || values.discount > 50)
        errors.discount = t('customer_group.error_discount');

    if (values.effectiveFrom && values.effectiveUntil) {
        const fromDate = new Date(values.effectiveFrom).getTime();
        const untilDate = new Date(values.effectiveUntil).getTime();

        if (untilDate < fromDate) {
            errors.effectiveUntil = t('customer_group.error_date_greater');
        }

        if (fromDate > untilDate) {
            errors.effectiveFrom = t('customer_group.error_date_smaller');
        }
    }

    if (values.effectiveFromTrip && values.effectiveUntilTrip) {
        const fromTripDate = new Date(values.effectiveFromTrip);
        const untilTripDate = new Date(values.effectiveUntilTrip);

        if (untilTripDate < fromTripDate) {
            errors.effectiveUntilTrip = t('customer_group.error_date_smaller');
        }

        if (fromTripDate > untilTripDate) {
            errors.effectiveUntil = t('customer_group.error_date_smaller');
        }
    }

    return errors;
};

const selector = formValueSelector('CustomerGroupDiscountEditForm');

const mapStateToProps = state => {
    return {
        effectiveFrom: selector(state, 'effectiveFrom'),
        effectiveFromTrip: selector(state, 'effectiveFromTrip'),
        effectiveUntil: selector(state, 'effectiveUntil'),
        effectiveUntilTrip: selector(state, 'effectiveUntilTrip'),
    };
};
CustomerGroupDiscountEditForm = connect(mapStateToProps)(CustomerGroupDiscountEditForm);

CustomerGroupDiscountEditForm = reduxForm({
    form: 'CustomerGroupDiscountEditForm',
    validate,
})(CustomerGroupDiscountEditForm);

export default CustomerGroupDiscountEditForm;
